import React from 'react';
import { Box, Typography } from '@mui/material';
import VendedorTable from '../components/vendedor/VendedorTable';

const Vendedores: React.FC = () => {
  return (
    <Box>
      <Typography 
        variant="h4" 
        component="h1" 
        gutterBottom 
        sx={{ 
          fontWeight: 'bold',
          fontFamily: 'Arial, sans-serif',
          fontSize: '2.125rem',
          lineHeight: 1.235
        }}
      >
        Vendedores
      </Typography>
      <VendedorTable />
    </Box>
  );
};

export default Vendedores;
